<template>
    <div id="classify">
        <van-nav-bar z-index='1' class="classify-title">
            <p slot="title">
              分类搜索
            </p>
        </van-nav-bar>
        <searchContent :businessProperty="2"></searchContent>
    </div>
</template>

<script>
import Scroll from '@/config/scroll';
import searchContent from './searchContent';
export default {
    components: {
        searchContent
    },
    name: 'Classify',
    mixins: [Scroll],
    data() {
        return {
        };
    },
    methods: {

    },
    created() {

    }
};
</script>
<style lang="scss">
    #classify{
      display: flex;
      flex-direction: column;
      height: 100%;
      padding-bottom: 50px;
      box-sizing: border-box;
      .van-nav-bar{
        p{
          font-size:21px;
          font-family:PingFang SC;
          font-weight:bold;
          color:rgba(0,0,0,1);
          line-height:44px;
          background:linear-gradient(-90deg,rgba(233,51,35,1) 0%, rgba(236,106,89,1) 100%);
          background-clip: text;
          -webkit-background-clip:text;
          -webkit-text-fill-color:transparent;
        }
      }
    }
</style>
